import { __assign } from "tslib";
import React, { useMemo } from 'react';
import { SplitFactory } from '@splitsoftware/splitio-react';
// hooks
import { useSplitToGTM } from '../../contexts/ABTestingProvider/hooks/useSplitToGTM';
import { useSplitFactory } from '../../contexts/ABTestingProvider/hooks/useSplitFactory';
import { useABTestingAPI } from '../../contexts/ABTestingProvider/hooks/useABTestingAPI';
// constants
import { LOCAL_MODE_KEY, TRAFFIC_TYPES } from '../../constants/ab-testing.constants';
export default function ABTestingProvider(props) {
    var isSSR = typeof window === 'undefined';
    return isSSR ? props.children : React.createElement(ClientABTestingProvider, __assign({}, props));
}
function ClientABTestingProvider(_a) {
    var appKey = _a.appKey, _b = _a.trafficType, trafficType = _b === void 0 ? TRAFFIC_TYPES.USER : _b, _c = _a.attributes, attributes = _c === void 0 ? {} : _c, _d = _a.defaultFeatures, defaultFeatures = _d === void 0 ? {} : _d, _e = _a.debug, debug = _e === void 0 ? false : _e, children = _a.children;
    var _f = useABTestingAPI(appKey, defaultFeatures), isLocal = _f.isLocal, features = _f.features;
    var authorizationKey = isLocal ? LOCAL_MODE_KEY : appKey;
    var factory = useSplitFactory({
        authorizationKey: authorizationKey,
        trafficType: trafficType,
        features: features,
        debug: debug
    });
    useSplitToGTM(factory);
    var key = useMemo(function () { return (isLocal ? JSON.stringify(features) : 'live'); }, [
        isLocal,
        features
    ]);
    return (React.createElement(SplitFactory, { key: key, factory: factory, attributes: attributes }, children));
}
//# sourceMappingURL=index.js.map